import { render, staticRenderFns } from "./TemplateDocumentosToolbar.vue?vue&type=template&id=44cc5d89&scoped=true&"
import script from "./TemplateDocumentosToolbar.vue?vue&type=script&lang=js&"
export * from "./TemplateDocumentosToolbar.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDocumentosToolbar.vue?vue&type=style&index=0&id=44cc5d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc5d89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
